<template>
    <div class="corporateCultureBox">
        <aboutBannerVue tabIndex="6"></aboutBannerVue>
        <div :class="isMobile?'mobileShow':'socialBox'">
           <p class="title">{{info.title}}</p>
            <div class="contents" :class="isMobile?'socialMobile':''" v-html="info.content"></div>
        </div>
    </div>
</template>

<script>
import aboutBannerVue from '@/components/aboutBanner'
	const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
const newApi = (path) => NEW_API_BASE + path
export default {
		name:'CorporateCulture',
        components:{aboutBannerVue},
        data() {
            return {
                info:'',
                list:[]
            }
        },
        mounted(){
           this.getInfo()
        },
       methods:{
         //获取社会价值详情
         getInfo(){
            this.Request({
                url: newApi('/hzfglSys/news/public/detail/' + this.$route.query.id),
                    baseURL: '',
                method: 'get',
            }).then((res) => {
                this.info = res.data; if(this.info && this.info.content){var el=document.createElement("textarea");el.innerHTML=this.info.content;this.info.content=el.value}
                // var list = res.data.content.split('</p>')
                // list[2] = list[2].replace('项目概况：','')
                // list[4] = list[4].replace('项目投资：','')
                // list[6] = list[6].replace('服务范围：','')
                // this.list = list
            })
        }
       }
	}
</script>
<style scoped>
    .mobileShow{
        padding-bottom: 30px;
    }
    .socialBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 80px;
        padding-bottom: 50px;
    }
    .title{
        font-size: 24px;
        font-weight: 400;
        padding-bottom: 30px;
        margin-bottom: 27px;
        border-bottom: 1px solid #E8E8E8;
        text-align: center;
    }
    .map{
        width: 520px;
        height: 367px;
    }
    .contents{
        margin-top: 64px;
    }
    .contents img{
        max-width: 100%;
    }
</style>
<style>
    .labelW{
        width: 161px;
        text-align: center !important;
    }
    .socialMobile img{
        max-width: 100%;
        height: auto !important;
    }
</style>